import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

/**
 * Default landing for authenticated users at `/`.
 * Sends post-onboarding users to /welcome (activation checklist + upgrade CTA)
 * unless they've already completed or dismissed it. Otherwise → /training.
 */
const DefaultRedirect = () => {
  const user = useAuthStore((s) => s.user)

  if (user && user.onboardingCompletedAt && !user.activationCompletedAt && !user.activationDismissedAt) {
    return <Navigate to="/welcome" replace />
  }
  return <Navigate to="/training" replace />
}

export default DefaultRedirect
